<template>
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <c-tab
        :dense="true"
        type="pagetop"
        :tabItems.sync="tabItems"
        :inlineLabel="true"
        setHeight="500px"
        v-model="tab"
      >
        <template v-slot:default="tab">
          <component
            dense
            :documentInfo.sync="documentInfo"
            :is="tab.component"
          />
        </template>
      </c-tab>
    </div>
  </div>
</template>
<script>
export default {
  name: 'firefighting-equipment-tab',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
      }),
    },
  },
  data() {
    return {
      tab: 'firefightingEquipmentDoc',
      documentInfo: {
        documentClassCd: 'EXAT', // EXAT
        title: '소화설비 설치',
      },
      tabItems: [],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.tabItems = [
        // // 기본정보 정보
        // { name: 'firefightingEquipmentInfo', icon: 'info', label: '소화설비 설치계획', component: () => import(`${'./firefightingEquipmentInfo.vue'}`) },
        // // 도면
        // { name: 'firefightingEquipmentPid', icon: 'tab', label: '소화설비 설치도', component: () => import(`${'./firefightingEquipmentPid.vue'}`) },
        // 문서
        { name: 'firefightingEquipmentDoc', icon: 'assignment', label: '소화설비 설치 계획 문서', component: () => import(`${'./firefightingEquipmentDoc.vue'}`) },
        // 화재탐지/경보설비 계획
        { name: 'fireDetectionAlarmSystemPid', icon: 'tab', label: '화재탐지 및 경보설비 설치계획도', component: () => import(`${'@/pages/psi/lbe/fdas/fireDetectionAlarmSystemPid.vue'}`) },
      ]
    },

  }
};
</script>